import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { MediaGroup } from 'src/app/models/media/media-group.model';
@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'filterActiveGroupsPipe',
  pure: false,
})
export class FilterActiveGroupPipe implements PipeTransform {
  transform(mediaGroups: MediaGroup[], isDisplayOnLeft: boolean): MediaGroup[] {
    const excludedGroups = ['unknown', 'additional'];
    return mediaGroups
      .filter(
        (mediaGroup) =>
          !excludedGroups.find(
            (g) => g.toLowerCase() === mediaGroup.name.toLowerCase()
          )
      )
      .filter(
        (mediaGroup) => mediaGroup.leftOrRight === (isDisplayOnLeft ? "Left" : "Right")
      )
      .sort((a, b) => a.sortOrder - b.sortOrder);
  }
}
